<template>
  <v-main>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col class="text-center" cols="12" sm="4">
          <div class="my-2">
            <v-btn v-if="e1===8 & currentGame.open" @click="endGame" color="red"
              >End Game</v-btn
            >
            <!-- <v-btn v-if="currentGame.open" @click="endGame" color="red"
              >End Game</v-btn
            > -->
            <!-- <v-btn v-else @click="startGame" color="green">Start Game</v-btn> -->
            <v-btn v-if="!currentGame.open" @click="startGame" color="green">Start Game</v-btn>
          </div>
        </v-col>
      </v-row>
      <div v-if="currentGame.id">
        <v-stepper v-model="e1" :vertical="vertical" :alt-labels="altLabels">
          <template v-if="vertical">
            <template v-for="n in steps">
              <v-stepper-step
                :key="`${n}-step`"
                :complete="e1 > n"
                :step="n"
                :editable="editable"
              >
                Step {{ n }}
              </v-stepper-step>

              <v-stepper-content :key="`${n}-content`" :step="n">
                <v-card
                  class="mb-12"
                  color="grey lighten-1"
                  height="200px"
                ></v-card>

                <v-btn color="primary" @click="nextStep(n)">
                  Continue
                </v-btn>

                <v-btn text>Cancel</v-btn>
              </v-stepper-content>
            </template>
          </template>
          <template v-else>
            <v-stepper-header>
              <template v-for="n in steps">
                <v-stepper-step
                  :key="`${n}-step`"
                  :complete="e1 > n"
                  :step="n"
                  :editable="editable"
                  @click.native="viewStep(n)"
                >
                  {{ step_labels[n - 1] }}
                </v-stepper-step>

                <v-divider v-if="n !== steps" :key="n"></v-divider>
              </template>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content
                v-for="n in steps"
                :key="`${n}-content`"
                :step="n"
              >
                <AdminReport
                  v-bind:step_label="step_labels[e1 - 1]"
                ></AdminReport>
                <v-btn v-if="e1!== 8 & currentGame.open" color="primary" @click="nextStep(n)">
                  Advance
                </v-btn>
              </v-stepper-content>
            </v-stepper-items>
          </template>
        </v-stepper>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import AdminReport from "@/components/AdminReport.vue";
import { gamesCollection, currentCollection, route_path } from "@/main";
export default {
  components: {
    AdminReport
  },
  data() {
    return {
      search: "",
      e1: 1,
      vertical: false,
      altLabels: true,
      editable: false,
      step_labels: [
        "Select Funded",
        "Strategy Review",
        "Roll Unfunded",
        "Unfunded Review",
        "Roll Funded",
        "Funded Review",
        "Pick Five Best",
        "Best of 5 Review"
      ],
      games: null
    };
  },
  computed: {
    steps() {
      return this.step_labels.length;
    },
    currentGame() {
      return this.$store.getters.currentGame;
      // return this.$store.state.currentGame.id;
    }
  },

  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
    vertical() {
      this.e1 = 2;
      requestAnimationFrame(() => (this.e1 = 1)); // Workarounds
    }
  },

  methods: {
    onInput(val) {
      this.steps = parseInt(val);
    },
    viewStep(n) {
      if (n <= this.e1) {
        alert(n.toString() + " - " + this.step_labels[n - 1]);
      }
    },
    nextStep(n) {
      if (n === this.steps) {
        // this.e1 = 1;
      } else {
        this.e1 = n + 1;
        this.$store.dispatch("updateGameStep", this.e1);
      }
    },
    startGame() {
      this.$store.dispatch("startNewGame");
      this.e1 = 1;
    },
    endGame() {
      this.$store.dispatch("endGame");
    }
  }
};
</script>
